import * as ActionType from '../constants/ActionType'

export const initialState = {
    'isAuthenticated': false,
    'username': null,
    'email': null,
    'userId': null,
    'sex': null,
    'loginError': false,
    'showLoginModal': false,
    'firstname': null,
    'lastname': null,
    'organisation': null,
    'companyName': null,
    'street': null,
    'streetNumber': null,
    'zip': null,
    'city': null,
    'country': null,
    'phone': null,
    'billingAddressSex': null,
    'billingAddressCompany': null,
    'billingAddressEmail': null,
    'billingAddressPhone': null,
    'billingAddressFirstname': null,
    'billingAddressLastname': null,
    'billingAddressStreet': null,
    'billingAddressZip': null,
    'billingAddressCity': null,
    'billingAddressCountry': null,
    'shoppingCartEmail': null,
};

function user(state = initialState, action) {
    switch (action.type) {
        case ActionType.LOGIN_REQUIRED:
            return {
                ...state,
                isAuthenticated: false,
                userId: null,
                username: null,
                loginError: false,
                showLoginModal: true
            };
        case ActionType.LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                userId: action.payload.id,
                username: action.payload.username,
                loginError: false,
                showLoginModal: false
            };
        case ActionType.LOGIN_ERROR:
            return {
                ...state,
                isAuthenticated: false,
                userId: null,
                username: null,
                loginError: true,
                showLoginModal: true
            };
        case ActionType.LOGIN_MODAL_OPEN:
            return {
                ...state,
                showLoginModal: true
            };
        case ActionType.LOGIN_MODAL_CLOSE:
            return {
                ...state,
                showLoginModal: false
            };
        case ActionType.USER_STATUS_SUCCESS:

            console.log('User payload - status success:', action.payload);
            return {
                ...state,
                isAuthenticated: true,
                userId: action.payload.id,
                sex: action.payload.sex,
                username: action.payload.username,
                email: action.payload.email,
                firstname: action.payload.firstname,
                lastname: action.payload.lastname,
                organisation: action.payload.organization.name,
                companyName: action.payload.companyName,
                street: action.payload.street,
                streetNumber: action.payload.streetNumber,
                zip: action.payload.zip,
                city: action.payload.city,
                country: action.payload.country,
                phone: action.payload.phone,
                showLoginModal: false,
                rightAccessOrganizationDocuments: action.payload.rightAccessOrganizationDocuments,
                rightChangeDocumentStorageUser: action.payload.rightChangeDocumentStorageUser,
                billingAddressSex: action.payload.billingAddressSex,
                billingAddressCompany: action.payload.billingAddressCompany,
                billingAddressEmail: action.payload.billingAddressEmail,
                billingAddressPhone: action.payload.billingAddressPhone,
                billingAddressFirstname: action.payload.billingAddressFirstname,
                billingAddressLastname: action.payload.billingAddressLastname,
                billingAddressStreet: action.payload.billingAddressStreet,
                billingAddressZip: action.payload.billingAddressZip,
                billingAddressCity: action.payload.billingAddressCity,
                billingAddressCountry: action.payload.billingAddressCountry,
                shoppingCartEmail: action.payload.shoppingCartEmail,
            };
        case ActionType.LOGOUT_SUCCESS:
            return {
                ...state,
                isAuthenticated: false,
                userId: null,
                username: null,
                showLoginModal: true
            };
        default:
            return state
    }
}

export default user


// WEBPACK FOOTER //
// ./src/js/reducers/user.js